module.exports = __webpack_public_path__ + "img/341.c9512f26.png";